import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googlePlay = defineConnector({
  identifier: "googlePlay",
  name: "Google Play",
  tagLine: "Android app distribution",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://play\\.googleapis\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Google Play app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Google Play Developer API getting started guide](https://developers.google.com/android-publisher/getting_started) and create a Google Cloud project and OAuth app for the Play Console account you want to use. Copy the client ID and client secret after you finish the setup.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/googlePlay/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Google Play account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Google Play account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/auth",
    tokenEndpoint: () => "https://accounts.google.com/o/oauth2/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://play.googleapis.com/",
  },
});
